'use client'
import { useTranslations } from 'next-intl'
import React, { ReactNode, useCallback } from 'react'
import ReactSelect, { StylesConfig } from 'react-select'
import HelperButton from '../HelperButton'
import { IHelperButton } from '../types'
import DropdownIndicator from './DropdownIndicator'
import './styles.scss'

export interface IOption {
  label: string
  value: string | number
}

export interface IGroupedOption {
  label: string
  options: IOption[]
}

interface InputSelectProps {
  inputName?: string
  options: IOption[] | IGroupedOption[]
  onChange?: (newValue: any) => void
  value?: any
  callSubmit?: () => void
  isDisabled?: boolean
  isSearchable?: boolean
  placeholder?: string
  labelText?: string
  fixedIcon?: string
  onBlur?: (newValue: any) => void
  isMulti?: boolean
  defaultValue?: any
  isClearable?: boolean
  hasError?: boolean
  alignLabel?: string
  hideSelectedOptions?: boolean
  helperButton?: IHelperButton
  tooltip?: string | ReactNode
  mode?: 'dark' | 'light'
  withRequiredLabel?: boolean
}

const selectStyles: StylesConfig = {
  control: css => ({ ...css, paddingLeft: '1rem' }),
}
const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}
const formatGroupLabel = (data: any) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
)

const InputSelect: React.FC<InputSelectProps> = ({
  alignLabel = 'top',
  labelText,
  inputName,
  onChange,
  callSubmit,
  placeholder,
  isMulti,
  isClearable,
  hasError,
  isSearchable,
  hideSelectedOptions = true,
  helperButton,
  tooltip,
  mode = 'dark',
  withRequiredLabel,
  ...props
}) => {
  const t = useTranslations('translation')

  const onChangeHandler = useCallback(
    (event: any) => {
      if (onChange) onChange(event)
      if (callSubmit) callSubmit()
    },
    [callSubmit, onChange],
  )

  return (
    <div
      className={`inputWrapper ${mode === 'dark' ? 'dark' : ''} ${
        hasError ? 'error' : ''
      }`}
    >
      {/* {labelText && (
        <Label htmlFor={inputName}>
          {labelText}{' '}
          {withRequiredLabel && <span className="requiredLabel">*</span>}
        </Label>
      )} */}
      <div className="selectWrapper">
        <ReactSelect
          {...props}
          isClearable={Boolean(isClearable)}
          options={props.options as any}
          noOptionsMessage={() => t('emptyOptions')}
          isLoading={false}
          classNamePrefix="react-select"
          hideSelectedOptions={hideSelectedOptions}
          isSearchable={isSearchable}
          placeholder={labelText || placeholder ? placeholder : t('select')}
          onChange={onChangeHandler}
          components={{
            DropdownIndicator,
          }}
          styles={selectStyles}
          formatGroupLabel={formatGroupLabel}
        />
        {helperButton && <HelperButton {...helperButton} tooltip={tooltip} />}
      </div>
    </div>
  )
}

export default React.memo(InputSelect)
